import { Link } from 'react-router-dom';
import { keszletekModulhoz } from '../../config/felismero';

/* A felismerők linkje a modulkártya alatt (zárt modulnál is: a 12 ingyenes feladat FREE-nek is nyitva):
   az Alakzatfelismerő a 9. modulnál („Diagram Minták Olvasása”), a Gyertyaminta-felismerő a 8.-nál
   („Gyertyák Elemzése”); a modulok a config/felismero.js-ben. Más modulnál semmit nem rajzol.
   A döntési gyakorló linkjének (GyakorloLink) mintájára. */
export default function AlakzatLink({ moduleId }) {
  return keszletekModulhoz(moduleId).map(k => (
    <Link key={k.keszlet} to={k.path} style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginTop: 10,
      padding: '10px 12px', borderRadius: 10, textDecoration: 'none',
      background: 'rgba(0,210,200,0.06)', border: '0.5px solid rgba(0,210,200,0.3)',
    }}>
      <span style={{ minWidth: 0 }}>
        <span style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#fff' }}>{k.ikon} {k.cim}</span>
        <span style={{ display: 'block', fontSize: 11, color: 'rgba(255,255,255,0.5)', marginTop: 2 }}>{k.linkSor}</span>
      </span>
      <span style={{ color: '#00D2C8', fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap' }}>Kipróbálom →</span>
    </Link>
  ));
}
